class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector(".menu-drawer");
    this.toggleButton = this.querySelector(".js-drawer-menu");
    this.backdrop = this.querySelector(".menu-drawer-backdrop");

    // reference & binds
    this.sidebarId = "wwkSidebarTop";
    this.sidebarTop = document.getElementById(this.sidebarId);

    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleEsc = this.handleEsc.bind(this);
    this._forceHide = this._forceHide.bind(this);
    this._onDomMut = this._onDomMut.bind(this);

    this._mo = null;

    this.bindElements();

    const searchWrapper = document.querySelector(".homepage-search");
    if (searchWrapper) {
      this.handleSearchBarOnScroll();
    }

    this.isOpen = false;
    // this.setDrawerHeight();
  }

  handleSearchBarOnScroll() {
    if (window.innerWidth > 768) return;

    const searchBar = document.querySelector(".mobile-search-bar");
    const drawerMenu = document.querySelector("menu-drawer");
    const predictive = document.querySelector("predictive-search");
    const footer = document.querySelector("footer");

    if (!searchBar || !drawerMenu) return;

    let lastScrollY = window.scrollY;
    let hasStartedScrolling = false;
    const HIDE_OFFSET = 200;

    window.addEventListener("scroll", (event) => {
      const currentScroll = window.scrollY;

      const footerRect = footer?.getBoundingClientRect();

      if (footerRect && footerRect.top < window.innerHeight) {
        searchBar.classList.add("search-bar--hidden");
        return;
      }

      if (!hasStartedScrolling) {
        hasStartedScrolling = true;
        lastScrollY = currentScroll;
        return;
      }

      if (
        this.isOpen == true &&
        predictive &&
        predictive.classList.contains("is-open")
      ) {
        this.isOpen = false;
      } else if (
        this.isOpen == false &&
        predictive &&
        predictive.classList.contains("is-open") == false
      ) {
        const goingDown = currentScroll > lastScrollY;
        const goingUp = currentScroll < lastScrollY;

        if (goingDown && currentScroll > HIDE_OFFSET) {
          searchBar.classList.add("search-bar--hidden");
        }

        if (goingUp) {
          searchBar.classList.remove("search-bar--hidden");
        }

        lastScrollY = currentScroll;
      } else {
        return;
      }
    });
  }

  open() {
    let resultsReccomend = document.querySelector(".ps-results-recommended");
    const popover = document.getElementById("ps-popover");
    const search = document.querySelector(".mobile-search-bar");
    const overlay = document.querySelector(".site-overlay");
    const standardPagePrdictiveSearch =
      document.querySelector(".standard-page-ps");

    if (search) {
      search.classList.remove("search-opened");
      overlay.classList.remove("overlay-shown");
    }
    if (standardPagePrdictiveSearch) {
      standardPagePrdictiveSearch.classList.remove("is-open");
    }

    let chat = document.getElementById("wwkSidebarTop");
    if(chat) {
      chat.style.display = "none";
    }

    this.classList.add("drawer-visible");
    this.isOpen = true;

    document.body.classList.add("overflow-hidden");

    //search adjustments
    if (search) search.classList.remove("search-bar--hidden");
    if (resultsReccomend)
      resultsReccomend.classList.add("hiiden-on-drawer-open");
    if (popover) popover.hidden = true;

    let chatClose = document.getElementById("shopify-chat");
    if (chatClose) chatClose.style.visibility = "hidden";

    const teaser = document.querySelector('[data-testid="animated-teaser"]');
    if (teaser) teaser.style.display = "none";

    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("keydown", this.handleEsc);

    // 1) initially hide
    this._forceHide();

    // 2)catch all scroll eventds and keep it hidden
    document.addEventListener("scroll", this._forceHide, /* capture */ true);
    window.addEventListener("scroll", this._forceHide, /* capture */ true);

    // observe body
    if (!this._mo) {
      this._mo = new MutationObserver(this._onDomMut);
      this._mo.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }
  }

  close() {
    let resultsReccomend = document.querySelector(".ps-results-recommended");
    const popover = document.getElementById("ps-popover");
    const search = document.querySelector(".mobile-search-bar");

    this.isOpen = false;
    this.classList.remove("drawer-visible");
    document.body.classList.remove("overflow-hidden");

    let chatClose = document.getElementById("shopify-chat");
    if (chatClose) chatClose.style.visibility = "visible";

    let chat = document.getElementById("wwkSidebarTop");
    if(chat) {
      chat.style.display = "block";
    }

    //search adjustments
    if (resultsReccomend)
      resultsReccomend.classList.remove("hiiden-on-drawer-open");

    const teaser = document.querySelector('[data-testid="animated-teaser"]');
    if (teaser) teaser.style.display = "";

    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleEsc);

    document.removeEventListener("scroll", this._forceHide, true);
    window.removeEventListener("scroll", this._forceHide, true);

    if (this._mo) {
      this._mo.disconnect();
      this._mo = null;
    }

    // revert it when closing drawer
    const el = document.getElementById(this.sidebarId);
    if (el) el.style.display = "block";
  }

  bindElements() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", (e) => {
        e.stopPropagation();
        this.classList.contains("drawer-visible") ? this.close() : this.open();
      });
    }

    if (this.drawer) {
      this.drawer.addEventListener("click", (e) => e.stopPropagation());
    }

    if (this.backdrop) {
      this.backdrop.addEventListener("click", () => this.close());
    }
  }

  handleOutsideClick(event) {
    const clickedInsideDrawer =
      this.drawer && this.drawer.contains(event.target);
    const clickedToggle =
      this.toggleButton && this.toggleButton.contains(event.target);

    if (!clickedInsideDrawer && !clickedToggle) this.close();

    console.log(clickedInsideDrawer);
    console.log(clickedToggle);

    const searchBar = document.querySelector(".header-search");
    if (searchBar.contains(event.target)) {
      this.isOpen = true;
    } else {
      this.isOpen = false;
    }
  }

  handleEsc(event) {
    if (event.key === "Escape" || event.key === "Esc") this.close();
  }

  setDrawerHeight() {
    const headerGroup = document.querySelector(
      ".shopify-section-group-header-group"
    );
    if (headerGroup) {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(headerGroup.getBoundingClientRect().bottom)}px`
      );
    } else {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `54px`
      );
    }
  }

  // ————— Helpers —————

  _forceHide() {
    const el = document.getElementById(this.sidebarId);
    if (!el) return;
    if (document.body.classList.contains("drawer-open")) {
      el.style.display = "none";
    }
  }

  _onDomMut(mutations) {
    for (const m of mutations) {
      if (m.type === "childList" || m.type === "attributes") {
        this._forceHide();
      }
    }
  }
}

customElements.define("menu-drawer", MenuDrawer);

// Header search
(function () {
  const headerSearch = document.querySelector(".header-search");
  const headerSearchWrapper = document.querySelector(".mobile-search-bar");
  const searchToggle = document.querySelector(".header-search__wrapper");
  const closeBtn = document.querySelector(".ps-clear-btn");
  const clearButtonInsideInput = document.querySelector(".ps-clear-input");
  const predictiveSearchElement = document.querySelector("predictive-search");
  const overlay = document.querySelector(".site-overlay");

  if (!headerSearch) return;

  const psInput =
    headerSearch.querySelector("#ps-input") ||
    headerSearch.querySelector('input[type="search"]');

  // close search
  const closeSearch = () => {
    headerSearchWrapper.classList.remove("search-opened");
    overlay.classList.remove("overlay-shown");
    document.body.classList.remove("overflow-hidden");
    const popover = headerSearch.querySelector("#ps-popover");
    if (popover) popover.hidden = true;
    if (psInput) psInput.value = "";
    if (clearButtonInsideInput) clearButtonInsideInput.classList.add("hidden");
    if (document.body.dataset.template === "index") {
      closeBtn.classList.add("hidden");
    }
  };

  searchToggle.addEventListener("click", (e) => {
    e.preventDefault();
    headerSearchWrapper.classList.toggle("search-opened");
    document.body.classList.toggle("overflow-hidden");
    overlay.classList.toggle("overlay-shown");

    if (predictiveSearchElement.classList.contains("is-open")) {
      predictiveSearchElement.classList.remove("is-open");
    } else {
      predictiveSearchElement.classList.add("is-open");
    }

    if (headerSearchWrapper.classList.contains("search-opened") && psInput) {
      psInput.focus();
    }
  });

  closeBtn.addEventListener("click", (e) => {
    e.preventDefault();
    headerSearchWrapper.classList.toggle("search-opened");
    overlay.classList.toggle(".overlay-shown");
    document.body.classList.toggle("overflow-hidden");
    if (predictiveSearchElement) {
      predictiveSearchElement.classList.remove("is-open");
    }

    closeSearch();
  });

  // close on click outside of popup
  document.addEventListener("click", (e) => {
    const clickedToggle = e.target.closest(".header-search__wrapper");
    if (clickedToggle) return;

    if (
      headerSearchWrapper.classList.contains("search-opened") &&
      !headerSearch.contains(e.target)
    ) {
      document.body.classList.remove("overflow-hidden");
      closeSearch();
    }
  });

  // close on escape
  headerSearch.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeSearch();
    }
  });
})();
